<template>
    <v-container>
        <v-row>
            <v-col cols="2">Фио студента: </v-col>
            <v-col>{{Fio}}</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">Курс:</v-col>
            <v-col>{{Kur}}</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">Образовательная программа:</v-col>
            <v-col>{{Prog}}</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">
                Количество активных проектов:
            </v-col>
            <v-col v-if="proj">{{proj}}</v-col>
            <v-col v-else> в поисках </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props:["Fio","Kur", "Prog", "proj"]
}
</script>